import { TPropsWithChildren } from '@ftd/types'

import { Column, TColumnProps } from '../atoms/Column'

export const FormColumn: TPropsWithChildren<TColumnProps> = ({ children, ...stackProps }) => (
  <Column w="auto" {...stackProps}>
    {children}
  </Column>
)
